import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';
import { NotificationService} from 'app/shared/notification/notification.service';
import { Store } from 'app/store/store';
import { StoreService } from 'app/store/store.service';
import { Status } from 'app/status/status';
import { HttpParams } from '@angular/common/http';
import { PartOrder } from 'app/partOrder/partOrder';
import { RequestPartService } from './requestPart.service';

@Component({
	template: `
		<h3 class="title" i18n="@@create-partOrder">Create Part Order</h3>

		<form *ngIf="form" [formGroup]="form" (ngSubmit)="create()">
			<fieldset class="fieldset">
				<legend class="legend" i18n="@@data-partOrder">Part Order data</legend>

				<div class="field-row">
					<div class="field-row-item">
						<label class="label" for="store" i18n="@@store">Branch</label>
						<mat-select [formControl]="form.controls['store']" [compareWith]="compareFn" disableRipple>
							<mat-option i18n="@@select-none">None</mat-option>
							<mat-option *ngFor="let opt of stores" [value]="opt">{{opt.name}}</mat-option>
						</mat-select>
						<validator [control]="form.controls['store']"></validator>
					</div>
				</div>
				<div class="field-row">
					<div class="field-row-item">
						<label class="label" for="description" i18n="@@description">Description</label>
						<textarea formControlName="description"></textarea>
					</div>
				</div>
			</fieldset>

			<div class="options">
				<button class="btn-text" type="submit" [disabled]="!form.valid">
					<span i18n="@@option-save">Save</span>
				</button>
			</div>
		</form>
	`
})
export class RequestPartCreateComponent implements OnInit {
	form: FormGroup;
	stores: Store[];

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private requestPartService: RequestPartService,
		private storeService: StoreService,
		private notificationService: NotificationService,
	) {
		let partOrder = new PartOrder();
		partOrder.statusPartOrder = new Status('po_draft');
		this.form = this.requestPartService.toFormGroup(partOrder);
	}

	ngOnInit() {
		this.storeService.getAll(
			new HttpParams().set('sort', 'name').set('collection', 'id, name')
		).subscribe(data => {
			this.stores = data['result'];
		});
	}

	create() {
		this.requestPartService.create(<PartOrder> this.form.value).subscribe(partOrder => {
			this.notificationService.sucessInsert(partOrder.id.toString());
			this.router.navigate([`../${partOrder.id}`], {relativeTo: this.activatedRoute});
		}, err => this.notificationService.error(err));
	}

	compareFn(c1: any, c2: any): boolean {
		return c1 && c2 ? c1.id === c2.id : c1 === c2;
	}
}
